import { render, staticRenderFns } from "./RewardsPage.vue?vue&type=template&id=3e736f56&scoped=true&"
import script from "./RewardsPage.vue?vue&type=script&lang=js&"
export * from "./RewardsPage.vue?vue&type=script&lang=js&"
import style0 from "./RewardsPage.vue?vue&type=style&index=0&id=3e736f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e736f56",
  null
  
)

export default component.exports